<template>
    <div class="organization-header">
        <div class="tabs">
              <router-link :to="{name}" v-for="({name, title}, key) in navs" :key="key+'nav_org'" class="tabs-item" tag="div" active-class="active">
                {{ title }}
              </router-link>
              <div v-if="url" class="tabs-item"><a :href="url" target="_blank">Экспорт товаров xml</a></div>
        </div>
        <!--<button>Добавить</button>-->
      <div class="rate" @click="$refs.SelectRate.open()" :v-if="rate"><app-rate-star :config="rate" /></div>
      <select-rate-modal ref="SelectRate" @saved="lockItemReviewButton"/>
    </div>
</template>

<script>
import AppRateStar from "@/components/app-rate-star";
import SelectRateModal from "@/components/modals/select-rate-modal";

export default {
    name: "OrganizationHeader",
  components: { AppRateStar, SelectRateModal},
  props:{
    rate:{
      type: Array,
    },
    dropshipping:{
      type: Boolean,
      default: false
    },
    users:{
      type: Boolean,
      default: false
    },
  },
  data: function () {
        return {

            navs: [
                {
                    title: 'Основное',
                    name: 'oprof',
                },
               /* {
                    name: 'Реквизиты',
                    href: '',
                },
                {
                    name: 'Филиалы',
                    href: '',
                },*/
                {
                    title: 'Торговые точки',
                    name: 'storePoints',
                },
                {
                    title: localStorage.getItem('type') == 1 ? 'Мои клиенты' : 'Поставщики',
                    name: 'partners',
                },
                // {
                //     title: 'Мой тариф',
                //     name: '',
                // },
            ],
            url: ''
        }
    },
    mounted() {
        if (!this.dropshipping) {
            if (localStorage.getItem('type') == 1) {
                this.navs.push({
                    title: 'Бренды',
                    name: 'brands',
                });
            }
        } else {
            this.navs = [];
            if (localStorage.getItem('type') == 2) {
                this.navs = [
                    {
                        title: 'Поставщики',
                        name: 'Dropshipping',
                    },
                    {
                        title: 'Комиссии',
                        name: 'drcompur',
                    },
                    {
                        title: 'Категории',
                        name: 'drcat',
                    },
                    {
                        title: 'Заказы',
                        name: 'dropur',
                    },
                ];
                this.getXml();
            } else {
                this.navs = [
                    {
                        title: 'Категории',
                        name: 'Dropshipping',
                    },
                    {
                        title: 'Заказы',
                        name: 'drprord',
                    },
                    {
                        title: 'Комиссия',
                        name: 'drcom',
                    },
                    {
                        title: 'Закупщики',
                        name: 'drpurchasers',
                    },
                ];
            }
        }

        if (this.users) {
          this.navs = [
            {
              title: 'Сотрудники',
              name: 'users',
            },
            {
              title: 'Приглашения',
              name: 'invites',
            }
          ];
        }
    },
    methods: {
        lockItemReviewButton(id){
          this.orders = this.orders.map((item)=>{
            if(item.id == id){
              item.disabled = true;
            }
            return item
          })
        },
        redirect(val) {
            this.$router.push(val);
        },
        getXml() {
            this.$http.post('/get-dropshipping-products-xml',{
                token: localStorage.getItem('token'),
            }).then(({data}) => {
                if (data.xml) {
                    this.url = data.xml.url
                }
            }).catch(function(){
                this.$toast.error('Ошибка!');
            })
        }
    }
}
</script>

<style scoped lang="scss">
.organization-header {
    height: 40px;
    margin-bottom: 18px;
    display: flex;
  align-items: center;
    justify-content: space-between;
    button{
        border: none;
        height: 40px;
        width: 20%;
        background: #2CB181;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
    }
}

.tabs{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  width: max-content;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #EEF0F3;

  &-item {
    margin: 0;
    position: relative;
    cursor: pointer;
    padding: 10px 15px;
    margin: 2px 0 2px 0;
    color: #7A818F;
  }
  &-item:first-child{
    margin-left: 2px;
  }
  &-item:last-child{
    margin-right: 2px;
  }
  &-item.active {
    background: #EEF0F3;
    border-radius: 4px;
  }

  &-item:after{
    border-left: 1px solid #EEF0F3;
    content: " ";
    position: absolute;
    top: 35%;
    right: 0;
    height: 30%;
    margin-top: auto;
    margin-bottom: auto;
  }
  &-item:last-child:after{
    border-left: unset;
  }
}
</style>